import Marquee from "react-fast-marquee";
import { Orbit } from "lucide-react";

const ITEMS = [
  "Microsoft Azure", "Amazon Web Services", "Kubernetes", "Docker", "Terraform",
  "Azure DevOps", "GraphQL", "React", ".NET", "Python", "GitOps", "DataDog",
];

export default function TechMarquee() {
  return (
    <div className="border-y border-nexblue/10 bg-white py-6 overflow-hidden" data-testid="tech-marquee" aria-hidden="true">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display text-sm font-semibold uppercase tracking-[0.28em] text-nexblue/55">{item}</span>
            <Orbit size={13} className="text-nexorange/70" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
